import { render, staticRenderFns } from "./OperationPaperDetail.vue?vue&type=template&id=467fa166&scoped=true&"
import script from "./OperationPaperDetail.vue?vue&type=script&lang=js&"
export * from "./OperationPaperDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467fa166",
  null
  
)

export default component.exports